<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <Comission />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import Comission from '@/components/reports/comissions/Comission'

export default {
  name: 'Comissions',
  components: {
    PageTitle,
    PageRowWrapper,
    Comission
  }
}
</script>